import { render } from "./TermsVote.vue?vue&type=template&id=1da7168d"
import script from "./TermsVote.vue?vue&type=script&lang=js"
export * from "./TermsVote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__